'use strict';

var _ = require('lodash');
var BenchmarkCarriersController = function BenchmarkCarriersController($scope, legendFilterService, hepService) {
  $scope.carrierList = '';
  $scope.resetCarrierList = function () {
    $scope.carrierList = '';
  };
  $scope.reloadCarrierList = function () {
    $scope.$evalAsync(function () {
      var selectedMarket = legendFilterService.getSelectedMarket() || '';
      var selectedCabin = legendFilterService.getSelectedCabin();
      if (!isMarketOrCabinSelectionChanged(selectedMarket, selectedCabin) || !selectedMarket) {
        return;
      }
      $scope.resetCarrierList();
      $scope.selectedMarket = selectedMarket;
      $scope.selectedCabin = selectedCabin;
      selectedMarket = selectedMarket.split('-');
      hepService.getBenchmarkCarriers(selectedMarket[0], selectedMarket[1], selectedCabin).then(function (hepResponse) {
        var carrierList = _.get(hepResponse, ['hepList', 0, 'properties', 'benchmarkCarriers'], []);
        $scope.carrierList = formatCarrierList(carrierList);
      });
    });
  };
  function isMarketOrCabinSelectionChanged(selectedMarket, selectedCabin) {
    return selectedMarket && selectedMarket !== $scope.selectedMarket || selectedCabin && selectedCabin !== $scope.selectedCabin;
  }
  function formatCarrierList(carrierList) {
    return !_.isEmpty(carrierList) ? carrierList.split(',').join(', ') : '';
  }
  $scope.$on('chart:DepartureDate:filterUpdate', function () {
    $scope.reloadCarrierList();
  });
};
BenchmarkCarriersController.$inject = ['$scope', 'PricingDepartureDatesLegendFilterService', 'HepService'];
module.exports = BenchmarkCarriersController;